"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = (theme) => ({
    root: {
        height: '100%',
        padding: '0 24px',
    },
    link: {
        color: theme.palette.linkColor,
        textDecoration: 'none',
        '& :hover': {
            textDecoration: 'none',
        },
    },
    skeletonBlock: {
        backgroundColor: theme.palette.greyScaleDeprecated[5],
        borderRadius: 8,
        marginTop: 143,
    },
    skeletonSegment: {
        backgroundColor: theme.palette.greyScaleDeprecated[5],
        borderRadius: 8,
        margin: 10,
    },
    segmentOuterSpacing: {
        marginTop: 140,
        height: '100%',
        width: '100%',
    },
    segmentInnerSpacing: {
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
    },
    segmentInnerSpacingTwo: {
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        marginTop: -195,
    },
    skeletonCircle: {
        backgroundColor: theme.palette.greyScaleDeprecated[5],
        position: 'absolute',
        left: '50%',
        top: '40%',
        transform: 'translate(-50%, -50%)',
    },
    zeroState: {
        position: 'fixed',
        width: '100%',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
});
exports.default = styles;
